// extracted by mini-css-extract-plugin
export default {"container":"BackToTopButton_container__pI-Sn","circle":"BackToTopButton_circle__LP9jJ","icon":"BackToTopButton_icon__gU9KW","text":"BackToTopButton_text__VVohI"};